import * as React from 'react'

import { ApplicationStep, Field } from 'embed/constants'
import { Fields } from 'embed/constants/fields'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationField } from 'embed/components/ApplicationField/container'
import { Product } from 'even-ts-static'
import { StepbystepCreditApplicationWrapper } from '../Wrapper'

export interface Props {
  directReferral: boolean
  dispatchReturnToOriginalStep: () => void
  handleChangeAndContinue: (field: Field, value: string) => void
  onBack: () => void
  onContinue: () => void
  shouldDisplayBackToSearch: boolean
  stepByStepApplicationStep: ApplicationStep | undefined
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
}

export const StepbystepApplicationStepCreditRewardsPurposes: React.SFC<Props> = (props) => (
  <StepbystepCreditApplicationWrapper {...props}>
    <StepTitle>What is most important to you?</StepTitle>
    <ApplicationField
      field={Fields.CreditCardRewardsGroupsButtonList}
      onChange={props.handleChangeAndContinue.bind(null, Fields.CreditCardRewardsGroupsButtonList)}
      product={Product.CreditCard}
      forceFocus={true}
    />
  </StepbystepCreditApplicationWrapper>
)
